import { render, staticRenderFns } from "./PhotoWithBottomProBadge.vue?vue&type=template&id=3d3d6276&scoped=true"
import script from "./PhotoWithBottomProBadge.vue?vue&type=script&lang=js"
export * from "./PhotoWithBottomProBadge.vue?vue&type=script&lang=js"
import style0 from "./PhotoWithBottomProBadge.vue?vue&type=style&index=0&id=3d3d6276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d6276",
  null
  
)

export default component.exports